import { AttributesMixin, Collection, define, Model, type } from "@type-r/models";
import { restfulIO } from "./endpoint";
import { InvoiceVaultCard } from "./invoiceVaultCard";

export interface AssetsVaultCardFilters extends AttributesMixin<typeof AssetsVaultCardFilters> { }
@define
export class AssetsVaultCardFilters extends Model {
    static attributes = {
        state: type(Number).value(0)
    }
}

export interface AssetsVaultCard extends AttributesMixin<typeof AssetsVaultCard> { }
@define
export class AssetsVaultCard extends Model {
    static endpoint = restfulIO('/api/v1/assetmaster/assets');
    static idAttribute = "assetId";


    static attributes = {
        assetId: String,
        filter: type(AssetsVaultCardFilters),
        sortBy: {
            name: 'createdOn',
            isAsc: false
        },

        invoicesVaultCard: type({ items: [InvoiceVaultCard], count: Number }).endpoint(restfulIO('./')).dontSave,
        selected: Collection.ofRefs(InvoiceVaultCard)
    }
}
